const CONTRIBUTOR_FIELD_VALUE_MAX_LENGTH = 250;

export default CONTRIBUTOR_FIELD_VALUE_MAX_LENGTH;
